// services/WorkspaceInvitation.js
import BaseStrapiCollection from "../base-strapi-collection/base-strapi-collection";

export default class WorkspaceInvitation extends BaseStrapiCollection {
    static kind = "collectionType";
    static singularName = "workspace-invitation";
    static pluralName = "workspace-invitations";
    static displayName = "WorkspaceInvitation";

    constructor() {
        super(`${WorkspaceInvitation.kind}`,`${WorkspaceInvitation.singularName}`,`${WorkspaceInvitation.pluralName}`);}

    async getAll(query = {}) {
        const qs = require('qs');
        const _query = qs.stringify({...query}, {
            encodeValuesOnly: true, // prettify URL
        });

        return await this.fetch(_query);
    }


    async getById(id, query = {}) {
        return await this.find(id, { populate: "*", ...query });
    }

    async createItem(data) {
        return await this.create(data);
    }

    async updateItem(id, data) {
        return await this.update(id, data);
    }

    async deleteItem(id) {
        return await this.delete(id);
    }

    async invite(data, workspaceDocumentId) {
        return await this.postAction("/create-workspace-invitation", data, {}, workspaceDocumentId);
    }
}
